export default {
  methods: {
    /**
     * Возвращает название показателя по ключу
     * @param subjectName Ключ
     * @returns {string}
     */
    getSubjectText (subjectName) {
      const subjects = {
        cpl: 'cpl',
        clicks: 'клики',
        conversions: 'конверсии',
        shows: 'показы',
        costs: 'расход'
      }
      return subjects[subjectName] !== undefined
        ? subjects[subjectName]
        : subjects.cpl
    }
  }
}
